import { AnyAction } from '@reduxjs/toolkit';
import { SET_CUSTOMER_ACTIVE } from '../action-types';
import type { ISetActiveCustomerAction } from '../actions';
import type { TActiveCustomer } from '../interfaces';

type TCustomerActiveState = TActiveCustomer | Record<string, never>;

export const customerActiveReducer = (
  state: TCustomerActiveState = {},
  action: AnyAction,
): TCustomerActiveState => {
  switch (action.type) {
    case SET_CUSTOMER_ACTIVE: {
      return {
        ...(action as ISetActiveCustomerAction).payload,
      };
    }
    default:
      return state;
  }
};
